import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useConfigContext } from '../config';
var typeDefs = {
  borderType: ['solid', 'dashed', 'dotted', 'double'],
  position: ['left', 'right', 'center'],
  type: ['vertical', 'horizontal'],
  theme: ['light', 'dark'],
  margin: ['large', 'default', 'small', 'none', Number]
};
var defaults = function defaults() {
  return {
    borderType: 'solid',
    position: 'center',
    type: 'horizontal',
    theme: 'light',
    margin: 'default'
  };
};
export var Divider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Divider, _Component);
  function Divider() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return Divider;
}(Component);
Divider.template = template;
Divider.typeDefs = typeDefs;
Divider.defaults = defaults;